import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgIconDirective } from '@styleguide/svg-icon/svg-icon.directive';

@Component({
  selector: 'kgr-backup-codes',
  templateUrl: './backup-codes.component.html',
  styleUrls: ['./backup-codes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconDirective],
})
export class BackupCodesComponent {
  @Input({ required: true }) codes: string[] = [];

  copy(): void {
    navigator.clipboard.writeText(this.codes.join('\n'));
  }

  download(): void {
    const blob = new Blob([this.codes.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'backup-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  }
}
